import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";

import { useInitSignupsListPageStore } from "Signups/SignupView/SignupsListAndArchivePage/signupsListPageStore";

import { useActiveSignups } from "../API/queryHooks";
import {
  useDebouncedSearchValue,
  useInitLatestSignupsVisited,
} from "../signupsAndEventsStore";

import AnimatedSignupRow from "./AnimatedSignupRow";

function SignupsList({ accentColor }) {
  useInitLatestSignupsVisited();
  useInitSignupsListPageStore();

  const activeSignups = useActiveSignups();
  const debouncedSearchValue = useDebouncedSearchValue();
  const [timerResetTrigger, setTimerResetTrigger] = useState({});
  const timerRef = useRef(0);

  useEffect(() => {
    timerRef.current = 0;
    setTimerResetTrigger({});
  }, [debouncedSearchValue]);

  return (
    <>
      {activeSignups?.map((signup) => (
        <AnimatedSignupRow
          key={signup.ID}
          signup={signup}
          accentColor={accentColor}
          timerRef={timerRef}
          timerResetTrigger={timerResetTrigger}
        />
      ))}
    </>
  );
}

SignupsList.propTypes = {
  accentColor: PropTypes.string,
};

export default SignupsList;
